<template>
  <div class="finish">
    <!-- 头部 -->
    <div class="header">
      <van-nav-bar
        left-arrow
        @click-left="onClickLeft"
      >
        <slot slot="left" name="left">
          <van-icon name="arrow-left" />
        </slot>
        <slot slot="title" name="title">
          <div class="header-title">提交结果</div>
        </slot>
      </van-nav-bar>
    </div>
    <div class="content">
      <div class="finish-text">
        <div class="icon huisuiyunfont">{{'\ue66d'}}</div>
        <div>已提交</div>
        <div>待商户处理完成后会将发票发送至您填写的邮箱或手机，请注意查收</div>
      </div>
    </div>
    <div class="btn" @click="onClickLeft">
      继续提交
    </div>
  </div>
</template>
<script>
import { NavBar, Icon } from 'vant'
export default {
  data () {
    return {}
  },
  methods: {
    onClickLeft () {
      this.$router.go(-1)
    }
  },
  components: {
    [NavBar.name]: NavBar,
    [Icon.name]: Icon
  }
}
</script>
<style lang="less" scoped>
.finish{
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}
.content{
  flex: 1;
  width: 100%;
}
.finish-text{
  width: 96%;
  margin: 0 auto;
  flex: 1;
  text-align: center;
  background: #fff;
  border-radius: 20px;
  margin-top: 24px;
  .icon{
    font-size: 200px;
    color: rgba(14, 169, 117, 1);
  }
}
.finish-text > div:nth-of-type(2) {
  font-size: 40px;
  font-weight: 600;
  color: #4A944E;
  text-align: center;
}
.finish-text > div:nth-of-type(3) {
  padding: 24px 80px;
  font-size: 28px;
  text-align: center;
  color: #999999;
}
.btn{
  margin: 0 auto;
  width: 90%;
  text-align: center;
  border-radius: 40px;
  background-color: #3378FF;
  color: #fff;
  font-size: 34px;
  font-weight: 600;
  padding: 16px 0;
  margin-bottom: 32px;
}
// 头部
.header{
  height: 100px;
  .header-title{
    font-size: 32px;
    font-weight: bold;
    color: #FFFFFF;
  }
  /deep/.van-nav-bar{
    height: 100px;
    line-height: 100px;
    .van-nav-bar__content{
      height: 100%;
    }
    background:#3378FF;
    .van-nav-bar__text{
      font-size: 28px;
      color: #FFFFFF;
    }
    .van-icon{
      font-size: 28px;
      font-weight: bold;
      color: #FFFFFF;
    }
    .van-nav-bar__left, .van-nav-bar__right{
      padding: 0px 24px;
    }
  }
}
</style>
